export enum LocaleId {
  English_GreatBritain = 'en-GB',
  English_Ireland = 'en-IE',
}
